<template>
  <div class="addquiz-page container">
    <h1 class="title" v-if="$route.query.lang">Adicionar tradução do Desafio (Idioma: {{$route.query.lang}})</h1>
    <h1 class="title" v-else>Adicionar Desafio (Idioma: {{DefaultLanguage}})</h1>
    <div class="page-content">
      <steps
        :current="currentStep"
        type="pills"
        :show-footer="false"
      >
        <step title="Dados iniciais" description="Adicione os dados básicos deste desafio">
          <quiz-form
            :on-submit="addQuiz"
            :is-disabled="isFormDisabled"
            :is-loading="isFormDisabled"
            button-label="Cadastrar e continuar"
          />
        </step>
        <step title="Respostas" description="Adicione as respostas desse Desafio">
          <h4 class="title is-5" v-if="answers.length > 0">Respostas adicionadas:</h4>
          <answer-viewer
            v-for="answer in answers"
            :key="answer.id"
            :answer="answer"
            :can-be-edited="true"
            :can-be-deleted="true"
            :on-delete="spliceAnswerFromList"
          />
          <h4 class="title is-5" v-if="answers.length > 0">Adicionar nova Resposta:</h4>
          <answer-form
            :on-submit="addAnswer"
            :is-disabled="isAnswerFormDisabled"
            :is-loading="isAnswerFormDisabled"
            :form-data="answerFormData"
            button-label="Salvar e adicionar outra"
          />
        </step>
      </steps>
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places/${$route.params.id}`" class="button is-link">Visualizar Lugar</router-link>
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import QuizForm from '../forms/QuizForm'
import AnswerForm from '../forms/AnswerForm'
import AnswerViewer from '../QuizAnswerViewer'
import { CreateQuiz, CreateQuizAnswer } from '../../api/quiz'
import { prepareFormData } from '../../helpers'

export default {
  name: 'AddQuizPage',
  mixins: [AsideMenuCtrlMixin],
  components: { QuizForm, AnswerForm, AnswerViewer },
  data () {
    return {
      isFormDisabled: false,
      isAnswerFormDisabled: false,
      currentStep: 0,
      quizId: '',
      quiz: {},
      answers: [],
      answerFormData: {
        text: '',
        correct: false
      }
    }
  },
  methods: {
    addQuiz (data) {
      // console.log(data)
      let formData = {
        ...data,
        language: this.$route.query.lang
      }
      // console.log(formData)
      CreateQuiz(
        prepareFormData(formData),
        this.$route.params.id,
        this.$route.params.quizId || null,
        this.$route.query.lang
      )
        .then(
          success => {
            this.quiz = success.data
            this.quizId = success.data.id
            this.currentStep = 1
            this.isFormDisabled = false
          },
          error => {
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível criar o Desafio agora. Tente novamente.',
              duration: 10000
            })
            this.isFormDisabled = false
          }
        )
    },
    addAnswer (data) {
      this.isAnswerFormDisabled = true
      let formData = { ...data, language: this.$route.query.lang || this.DefaultLanguage }
      // console.log(formData)
      CreateQuizAnswer(
        formData,
        this.$route.params.id,
        this.quizId,
        this.$route.query.lang
      )
        .then(
          success => {
            // console.log(success.data)
            this.answers.push(success.data)
            this.isAnswerFormDisabled = false
            this.answerFormData = {
              text: '',
              correct: false
            }
            this.$notify.open({
              type: 'success',
              content: 'Resposta adicionada com sucesso.',
              duration: 10000
            })
          },
          error => {
            console.log(error.response)
            this.isAnswerFormDisabled = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível criar a Resposta agora. Tente novamente.',
              duration: 10000
            })
          }
        )
    },
    spliceAnswerFromList (answer) {
      this.answers.splice(this.answers.indexOf(answer), 1)
    }
  },
  computed: {
    ...mapGetters(['DefaultLanguage'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/AddQuizPage.vue